import React from "react"
import Styles from "./videoYouTube.module.scss"

const VideoYouTube = props => {
  const { youTubeId } = props

  return (
    <div className={Styles.container}>
      <div />
      <div className={Styles.iframeWrapper}>
        <iframe
          className={Styles.iframe}
          src={`https://www.youtube.com/embed/${youTubeId}`}
          title="EXO Video Player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <div />
    </div>
  )
}

export default VideoYouTube
